export const state = () => ({
    invoices: null,
    status: null,
    order: {
        order_by: 'created_at',
        order_dir: 'desc',
    },
    search: null,
    from_date: null,
    to_date: null,
});

export const mutations = {
    setInvoices(state: any, payload: any) {
        state.invoices = payload;
    },

    setStatus(state: any, payload: any) {
        state.status = payload;
    },

    setOrder(state: any, payload: any) {
        state.order = payload;
    },

    setSearch(state: any, payload: any) {
        state.search = payload;
    },

    setFromDate(state: any, payload: any) {
        state.from_date = payload;
    },

    setToDate(state: any, payload: any) {
        state.to_date = payload;
    },
};

export const getters = {
    getInvoices: (state: any) => state.invoices,

    getStatus: (state: any) => state.status,

    getOrder: (state: any) => state.order,

    getSearch: (state: any) => state.search,

    getFromDate: (state: any) => state.from_date,

    getToDate: (state: any) => state.to_date,
};

export const actions = {
    getInvoices(state: any, payload: any) {
        const company_uuid = this.$auth.user.company.uuid;

        let url = payload?.url || `/api/company/${company_uuid}/invoices`;

        let data = {
            ...state.state.order,
            status: state.state.status,
            search: state.state.search,
            from_date: state.state.from_date,
            to_date: state.state.to_date,
        };

        // Delete empty keys from the data
        Object.keys(data).forEach((key) => !data[key] && delete data[key]);

        return new Promise((resolve, reject) => {
            this.$axios
                .get(url, { params: { ...data } })
                .then((res) => {
                    state.commit('setInvoices', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    createInvoice(state: any, payload: any) {
        const company_uuid = this.$auth.user.company.uuid;

        return new Promise((resolve, reject) => {
            this.$axios
                .post(`/api/company/${company_uuid}/invoices`, payload)
                .then((res) => {
                    state.dispatch('getInvoices');
                    resolve(res.data);
                })
                .catch((err) => reject(err));
        });
    },

    voidInvoice(state: any, invoice_uuid: string) {
        return new Promise((resolve, reject) => {
            this.$axios
                .put(`/api/invoices/${invoice_uuid}/void`)
                .then((res) => {
                    state.dispatch('getInvoices');
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    setStatus(state: any, payload: any) {
        state.commit('setStatus', payload);
    },

    setOrder(state: any, payload: any) {
        state.commit('setOrder', payload);
    },

    setSearch(state: any, payload: any) {
        state.commit('setSearch', payload);
    },

    setFromDate(state: any, payload: any) {
        state.commit('setFromDate', payload);
    },

    setToDate(state: any, payload: any) {
        state.commit('setToDate', payload);
    },
};
